import { Box, styled } from '@chakra-ui/react'

const Card = styled(Box)

Card.defaultProps = {
  border: '1px solid',
  borderColor: 'gray.200',
  boxShadow: '0 0.25rem 1rem rgba(0, 0, 0, 0.075)'
}

export default Card
